import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { API_URL } from '../config'; // ★これを追加

export default function LoginPage({ onLogin }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  // 画面が開いた瞬間、ログイン済みかチェックする
  useEffect(() => {
    const savedUserId = localStorage.getItem("userId");
    if (savedUserId) {
      navigate("/main", { replace: true });
    }
  }, [navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      // ▼▼▼ 変更点: FormData ではなく JSON で送るように修正 ▼▼▼
      const res = await fetch(
  `${API_URL}?action=login`, // ★ URLを直接書かずに API_URL を使う
  {
    method: "POST",
          headers: {
            "Content-Type": "application/json", // JSONであることを明示
          },
          // データをJSON文字列に変換して送る
          body: JSON.stringify({
            username: username,
            password: password,
          }),
          credentials: "include", // セッション維持に必須
        }
      );
      // ▲▲▲ 変更ここまで ▲▲▲

      const data = await res.json();

      if (data.success && data.user) {
        const userId = Number(data.user.id);
        const userNameDisplay = data.user.name || "名前不明"; 
        const isAdmin = Number(data.user.isAdmin) === 1;
        // PHP側で追加した isManager も受け取る
        const isManager = data.user.isManager ? true : false; 

        localStorage.setItem("userId", String(userId));
        localStorage.setItem("userName", userNameDisplay);
        localStorage.setItem("isAdmin", isAdmin ? "true" : "false");
        // ★追加: 管理職フラグも保存しておく（あとで使うかもしれないため）
        localStorage.setItem("isManager", isManager ? "true" : "false");

        if (onLogin) {
          onLogin(userId, userNameDisplay, isAdmin);
        }

        navigate("/main", { replace: true });
        return;
      }

      setError(data.error || "ログインに失敗しました");
    } catch (err) {
      console.error("通信エラー:", err);
      setError("サーバーに接続できませんでした");
    } finally {
      setLoading(false);
    }
  };

  return (
    // 画面全体を薄いグレーにし、上下左右中央に配置する
    <div className="min-h-screen flex items-center justify-center bg-gray-100 px-4">
      
      {/* ログインカード */}
      <div className="max-w-sm w-full bg-white rounded-lg shadow-lg p-8">
        
        {/* タイトル部分 */}
        <div className="text-center mb-8">
          <h1 className="text-2xl font-bold text-gray-800 tracking-wide">
            勤怠管理システム
          </h1>
          <p className="text-sm text-gray-500 mt-2">
            従業員ログインポータル
          </p>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label className="block text-gray-700 text-sm font-bold mb-2">
              ユーザーID
            </label>
            <input
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              className="appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline focus:border-blue-500"
              placeholder="IDを入力してください"
              required
            />
          </div>

          <div className="mb-6">
            <label className="block text-gray-700 text-sm font-bold mb-2">
              パスワード
            </label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline focus:border-blue-500"
              placeholder="パスワードを入力してください"
              required
            />
          </div>

          {error && (
            <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-2 rounded mb-4 text-sm text-center">
              {error}
            </div>
          )}

          <div className="flex items-center justify-between">
            <button
              type="submit"
              disabled={loading}
              className={`w-full bg-blue-600 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline transition duration-150 ${
                loading ? "opacity-50 cursor-not-allowed" : ""
              }`}
            >
              {loading ? "認証中..." : "ログイン"}
            </button>
          </div>
        </form>
        
        {/* フッター */}
        <div className="mt-6 text-center text-xs text-gray-400">
          &copy; 2025 株式会社ジャパンテレビ
        </div>
      </div>
    </div>
  );
}